var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.site_key)?_c('vue-recaptcha',{attrs:{"sitekey":_vm.site_key,"size":_vm.$q.screen.lt.sm ? 'compact' : 'normal'},on:{"verify":_vm.verifyCaptcha}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }